module.exports = __webpack_public_path__ + "img/front_13.c21e6837.svg";